import { Tooltip } from '@lune-fe/lune-ui-lib'
import { FC, ReactElement } from 'react'

import ConditionalTooltip from 'components/ConditionalTooltip'

interface EmissionConditionalTooltipProps {
    slug: string | undefined
    emissionType: string
    children: ReactElement
}

const EmissionConditionalTooltip: FC<EmissionConditionalTooltipProps> = ({
    slug,
    emissionType,
    children,
}) => {
    return (
        <ConditionalTooltip
            show={slug === undefined}
            tooltip={({ children }) => (
                <Tooltip
                    style={{ width: '100%' }}
                    title={`${emissionType} can be viewed and edited only via the API`}
                    placement="top"
                >
                    {children}
                </Tooltip>
            )}
        >
            {children}
        </ConditionalTooltip>
    )
}

export default EmissionConditionalTooltip
